import React from "react";
import { Form } from "react-bootstrap";

const LocalizedTextField = ({
  label,
  values,
  language,
  onLanguageChange,
  onChange,
  placeholder,
  rows = 3,
  required = false
}) => {
  const activeLanguage = language === "ar" ? "ar" : "en";
  return (
    <Form.Group className="localized-text-field">
      <div className="localized-text-field-header">
        <Form.Label>{label}</Form.Label>
        <Form.Select
          aria-label={`${label} language`}
          value={activeLanguage}
          onChange={(event) => onLanguageChange(event.target.value)}
        >
          <option value="en">🇬🇧 EN</option>
          <option value="ar">🇪🇬 AR</option>
        </Form.Select>
      </div>
      <Form.Control
        as="textarea"
        dir={activeLanguage === "ar" ? "rtl" : "ltr"}
        lang={activeLanguage}
        rows={rows}
        required={required}
        value={values?.[activeLanguage] || ""}
        placeholder={placeholder}
        onChange={(event) => onChange(activeLanguage, event.target.value)}
      />
    </Form.Group>
  );
};

export default LocalizedTextField;
